import { useTranslate } from "#src/hooks";
import { Button } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

interface AvatarPreviewSelectButtonProps {
  onClick: () => void;
}

export const AvatarPreviewSelectButton = ({
  onClick,
}: AvatarPreviewSelectButtonProps) => {
  const { theme } = useAntTheme();
  const t = useTranslate();

  return (
    <Button
      onClick={onClick}
      size="small"
      style={{
        padding: "0px 5px",
        color: theme.colorBgElevated,
        backgroundColor: theme.colorTextSecondary,
        border: "none",
        lineHeight: 1.5,
        height: "auto",
      }}
    >
      {t("components.ContactWithPresenter.AvatarFacePreview.select")}
    </Button>
  );
};
